import KlaviyoForm from '@klv/atoms/klaviyo-form';
import Buttons from '@klv/molecules/buttons';
import { SingleLineForm } from '@klv/atoms/single-line-form';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from '../styles/hero.module.scss';

import type { IHeroContentsProps } from '../types';
import type { TColorVariant } from '@klv/shared/styles/types';

const HeroContents = ({
  eyebrow,
  eyebrowColor,
  eyebrowFont,
  eyebrowTag,
  headline,
  bodyCopy,
  largeText,
  embeddedForm,
  hasForm,
  formId,
  buttons,
  background,
  showSingleLineForm,
  singleLineForm,
  textAlign,
  mediaType,
  rive,
  hasMedia,
}: IHeroContentsProps) => {
  // This let's us honor the line breaks from the CMS
  const formattedHeadline = headline ? headline.replace(/\n/g, '<br/>') : '';
  const containerClassName = mediaType === 'rive' && rive?.riveFile ?
    styles.riveContentContainer :
    generateClassName([styles.contentContainer, hasMedia ? styles.hasMedia : '']);
  const showForm = embeddedForm !== 'kform' && embeddedForm !== 'hubspotform' && embeddedForm !== 'demoHubSpot' && hasForm && formId;
  
  const EyebrowTag = eyebrowTag || 'div';

  return (
    <div className={containerClassName}>
      {eyebrow && (
        <EyebrowTag
          className={generateClassName([
            'eyebrow',
            'smPaddingTop',
            styles.eyebrow,
            styles[eyebrowColor as keyof typeof styles],
            styles[eyebrowFont as keyof typeof styles],
          ])}
        >
          {eyebrow}
        </EyebrowTag>
      )}
      {headline && (
        <h1
          className={generateClassName([
            largeText ? 'display3' : 'h1',
            'semiBold',
            styles.headline,
          ])} 
          dangerouslySetInnerHTML={{ __html: formattedHeadline }}
        />
      )}
      {bodyCopy && (
        <div
          className={generateClassName([
            largeText ? styles.bigBodyCopy : '',
            styles.bodyCopy,
          ])} 
          dangerouslySetInnerHTML={{ __html: bodyCopy }}
        />
      )}
      {showForm && <KlaviyoForm formId={formId} />}
      {showSingleLineForm && singleLineForm && (
        <div className={styles.singleLineFormContainer}>
          <SingleLineForm 
            backgroundColor={background as TColorVariant} 
            primaryButtonText={singleLineForm.primaryButtonText} 
            placeholderText={singleLineForm.placeholderText} 
          />
        </div>
      )}
      <Buttons
        className={generateClassName([styles.riveButtons, textAlign === 'center' ? styles.center : ''])}
        buttons={buttons}
        buttonColor={(background !== 'charcoal') ? 'dark' : 'light'}
        variants={['primary', 'ghost']}
      />
    </div>
  );
};

export default HeroContents;
